import {FC} from 'react'
import {Link} from 'react-router-dom'
import {AppRoute, SidebarTranslations as st} from 'Services/I18n/Constants'

import {FormattedMessage} from 'react-intl'
import {getRoute} from 'Services/I18n/Utils'

export const SeekerMyProfileLinks: FC = () => {
  return (
    <>
      <h2>
        <FormattedMessage id={st.myProfile} />
      </h2>
      <ul>
        <li>
          <Link to={getRoute(AppRoute.PublicProfile)}>
            <FormattedMessage id={st.publicProfile} />
          </Link>
        </li>
        <li>
          <Link to={getRoute(AppRoute.Profile)}>
            <FormattedMessage id={st.myCv} />
          </Link>
        </li>
        <li>
          <Link to={getRoute(AppRoute.Assessments)}>
            <FormattedMessage id={st.assessments} />
          </Link>
        </li>
      </ul>
    </>
  )
}
